var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.3125C3 4.9328 3.3078 4.625 3.6875 4.625H15.9186C16.2983 4.625 16.6061 4.9328 16.6061 5.3125V5.3125C16.6061 5.6922 16.2983 6 15.9186 6H3.6875C3.3078 6 3 5.6922 3 5.3125V5.3125ZM6.0303 9.75C6.0303 9.33579 6.36609 9 6.7803 9H15.8561C16.2703 9 16.6061 9.33579 16.6061 9.75V9.75C16.6061 10.1642 16.2703 10.5 15.8561 10.5H6.7803C6.36609 10.5 6.0303 10.1642 6.0303 9.75V9.75ZM3 14.25C3 13.8358 3.33579 13.5 3.75 13.5H15.8561C16.2703 13.5 16.6061 13.8358 16.6061 14.25V14.25C16.6061 14.6642 16.2703 15 15.8561 15H3.75C3.33579 15 3 14.6642 3 14.25V14.25ZM6.0303 18.75C6.0303 18.3358 6.36609 18 6.7803 18H15.8561C16.2703 18 16.6061 18.3358 16.6061 18.75V18.75C16.6061 19.1642 16.2703 19.5 15.8561 19.5H6.7803C6.36609 19.5 6.0303 19.1642 6.0303 18.75V18.75ZM19.6364 3.68182C19.6364 3.30526 19.9416 3 20.3182 3V3C20.6947 3 21 3.30526 21 3.68182V20.3182C21 20.6947 20.6947 21 20.3182 21V21C19.9416 21 19.6364 20.6947 19.6364 20.3182V3.68182Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-right.32d512bdab75e9d10865877d0ee95041.svg";